// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"e23f5ae6","371":"e23f5ae6"}[chunkId] + ".chunk.css";
};